import {
  IconBrowserCheck,
  IconHelp,
  IconLayoutDashboard,
  IconPalette,
  IconSettings,
  IconUserCog,
  IconBrandGoogleAnalytics,
  IconQrcode,
  IconMenu,
  IconApps,
  IconShield,
  IconBuilding,
  IconCreditCard,
} from '@tabler/icons-react'
const user = useAuthStore.getState().auth.getUser()
import { AudioWaveform, Command, GalleryVerticalEnd } from 'lucide-react'
import { type SidebarData } from '../types'
import { useAuthStore } from '@/stores/authStore.ts'

export const sidebarData: SidebarData = {
  user: {
    name: user?.name,
    last_name: user?.last_name,
    email: user?.email,
    avatar: '/avatars/shadcn.jpg',
  },
  teams: [
    {
      name: 'Shadcn Admin',
      logo: Command,
      plan: 'Vite + ShadcnUI',
    },
    {
      name: 'Acme Inc',
      logo: GalleryVerticalEnd,
      plan: 'Enterprise',
    },
    {
      name: 'Acme Corp.',
      logo: AudioWaveform,
      plan: 'Startup',
    },
  ],
  navGroups: [
    {
      title: 'General',
      items: [
        {
          title: 'Dashboard',
          url: '/',
          icon: IconLayoutDashboard,
        }
      ],
    },
    {
      title: 'Management',
      items: [
        {
          title: 'Menu',
          url: '/menu',
          icon: IconMenu,
        },
        {
          title: 'Menu Editor',
          url: '/menu-editor',
          icon: IconPalette,
        },
        {
          title: 'QR',
          url: '/qr',
          icon: IconQrcode,
        }
      ],
    },
    {
      title: 'Stats',
      items: [
        {
          title: 'Analytics',
          url: '/analytics',
          icon: IconBrandGoogleAnalytics,
        }
      ],
    },
    {
      title: 'Integrations',
      items: [
        {
          title: 'Apps',
          url: '/apps',
          icon: IconApps,
        }
      ],
    },
    {
      title: 'Other',
      items: [
        {
          title: 'Settings',
          icon: IconSettings,
          items: [
            {
              title: 'Profile',
              url: '/settings',
              icon: IconUserCog,
            },
            {
              title: 'Security',
              url: '/settings/security',
              icon: IconShield,
            },
            {
              title: 'Organization',
              url: '/settings/organization',
              icon: IconBuilding,
            },
            {
              title: 'Billing',
              url: '/settings/billing',
              icon: IconCreditCard,
            },
            {
              title: 'Shop',
              url: '/settings/shop',
              icon: IconBrowserCheck,
            },
          ],
        },
        {
          title: 'Help Center',
          url: '/help-center',
          icon: IconHelp,
        },
      ],
    },
    {
      title: 'Administrator',
      adminOnly: true,
      items: [],
    },
  ],
}
